import { render, staticRenderFns } from "./CreateAddress.vue?vue&type=template&id=2d187d77&scoped=true"
import script from "./CreateAddress.vue?vue&type=script&lang=js"
export * from "./CreateAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d187d77",
  null
  
)

export default component.exports